import React from "react";
 
/**
 * Pixel-precise diagram component that replicates the "OUR WISE FRAMEWORK"
 * layout.
 */
const WiseFrameworkWithLines = () => {
  const handleClick = (name) => {
    alert(`You clicked: ${name}`);
  };
 
  // container dimensions (used visually; svg viewBox matches these)
  const width = 1200;
  const height = 420;
 
  return (
    // <-- PRIMARY FIXES: enable GPU compositing, hide overflow, and hint will-change
    <div
      className="relative w-full ml-[-70px] md:ml-0"
      style={{
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        willChange: "transform",
        overflow: "hidden", // hide subpixel artifacts at edges
      }}
    >
      {/* Heading Container */}
      <div
        className="w-full flex justify-center mb-10"
        style={{ position: "relative" }}
      >
        <div
          className="w-full flex justify-center mb-2"
          style={{ position: "relative" }}
        >
          <h2
            className="font-extrabold text-transparent ml-4"
            style={{
              fontFamily: 'Calibri, sans-serif',
              fontSize: '2rem',
              lineHeight: '1.3',
              letterSpacing: '0.05em',
              WebkitTextStroke: '1.5px white',
            }}
          >
            OUR WISE FRAMEWORK
          </h2>
        </div>
      </div>
 
      {/* Diagram Section */}
      <div className="flex w-full justify-start md:justify-center">
        <div
          className="relative select-none transform md:translate-x-0 -translate-x-24"
          style={{ width: `${width}px`, height: `${height}px` }}
        >
          {/* ---------- LEFT: Data Input Column ---------- */}
          <div style={{ left: 135, top: 45 }} className="absolute text-white">
            <div className="text-sm font-semibold mb-6 ml-6 -mt-7">Data Input</div>
 
            {/* Purple line below the header row */}
            <div
              className="absolute"
              style={{
                left: 0,
                top: 2,
                width: 915,
                height: 1, // integer px — avoid subpixel height
                backgroundColor: "#8B5CF6",
              }}
            ></div>
 
            {/* vertical rule - changed from 0.5px to 1px */}
            <div
              className="absolute"
              style={{
                left: 145,
                top: 3,
                width: 1, // <--- changed from 0.5 to 1
                height: 300 - 3,
                backgroundColor: "#8B5CF6",
              }}
            ></div>
 
            <ClickableBox
              onClick={() => handleClick("Image/Videos")}
              style={{ left: 0, top: 60, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Image/Videos"
            />
            <ClickableBox
              onClick={() => handleClick("Text")}
              style={{ left: 0, top: 110, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Text"
            />
            <ClickableBox
              onClick={() => handleClick("Numbers")}
              style={{ left: 0, top: 160, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Numbers"
            />
          </div>
 
          {/* ---------- PRE PROCESSING: two vertical rotated bars ---------- */}
          <div className="absolute" style={{ left: 285, top: 60 }}>
            <div className="text-sm font-semibold mb-6 ml-2 -mt-11 text-white">PreProcessing</div>
 
            {/* avoid subpixel line width */}
            <div
              className="absolute"
              style={{
                left: 100,
                top: -13,
                width: 1, // <--- changed from 0.5 to 1
                height: 285 + 13,
                backgroundColor: "#8B5CF6",
              }}
            ></div>
 
            <RotatedBox
              onClick={() => handleClick("Data cleansing and preparation")}
              style={{
                width: 42,
                height: 255,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              borderColor="#00f7d0"
              text={
                <span
                  style={{
                    display: 'inline-block',
                    transform: 'rotate(360deg)',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
                >
                  Data cleansing and preparation
                </span>
              }
            />
          </div>
 
          <div className="absolute" style={{ left: 335, top: 60 }}>
            <RotatedBox
              onClick={() => handleClick("WISE data generation tool")}
              style={{
                width: 42,
                height: 255,
                highlight: true,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              borderColor="#7D67EA"
              text={
                <span
                  style={{
                    display: 'inline-block',
                    transform: 'rotate(360deg)',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
                >
                  WISE data generation tool
                </span>
              }
            />
          </div>
 
          {/* ---------- CENTER: Compute area with stacked rows ---------- */}
          <div
            className="absolute"
            style={{ left: 360, top: 30, width: 520, height: 260 }}
          >
            <div className="text-sm font-semibold mb-0 ml-48 -mt-4 text-white">Compute</div>
 
            {/* vertical center rule — integer width */}
            <div
              className="absolute"
              style={{
                left: 430,
                top: 18,
                width: 1, // changed to 1 px
                height: 297,
                backgroundColor: "#8B5CF6",
              }}
            ></div>
 
            {/* Row 1 */}
            <ClickableBox
              onClick={() => handleClick("Image processing")}
              style={{
                left: 40,
                top: 32,
                width: 180,
                height: 58,
                borderWidth: 3,
                borderRadius: 12,
              }}
              borderColor="#7D67EA"
              text="Image processing"
            />
 
            <ClickableBox
              onClick={() => handleClick("Computer vision algorithms & ML methods")}
              style={{
                left: 225,
                top: 32,
                width: 190,
                height: 58,
                borderWidth: 3,
                borderRadius: 12,
              }}
              borderColor="#2ef0d6"
              text={
                <span>
                  Computer vision algorithms
                  <br />
                  & ML methods
                </span>
              }
            />
 
            {/* Row 2 */}
            <ClickableBox
              onClick={() => handleClick("NLP")}
              style={{ left: 40, top: 98, width: 180, height: 48 }}
              borderColor="#7D67EA"
              text="NLP"
            />
            <ClickableBox
              onClick={() => handleClick("Apache OpenNLP")}
              style={{ left: 225, top: 96, width: 190, height: 48, borderWidth: 3 }}
              borderColor="#2ef0d6"
              text="Apache OpenNLP"
            />
 
            {/* Row 3 */}
            <ClickableBox
              onClick={() => handleClick("Analysis of structured data")}
              style={{ left: 40, top: 154, width: 180, height: 70 }}
              borderColor="#7D67EA"
              text="Analysis of structured data"
            />
            <ClickableBox
              onClick={() =>
                handleClick(
                  "Machine Learning (SVM, Clustering, Neural Networks), DL Approaches"
                )
              }
              style={{
                left: 225,
                top: 154,
                width: 190,
                height: 70,
                borderWidth: 4,
                highlight: true,
              }}
              borderColor="#2ef0d6"
              text={
                <span>
                  Machine Learning (SVM,
                  <br />
                  Clustering, Neural Networks),
                  <br />
                  DL Approaches
                </span>
              }
            />
 
            {/* Bottom wide 'Design Implementation using Python/C++' */}
            <ClickableBox
              onClick={() => handleClick("Design Implementation using Python/C++")}
              style={{ left: 40, top: 240, width: 385, height: 46 }}
              borderColor="#7D67EA"
              text="Design Implementation using Python/C++"
            />
          </div>
 
          {/* ---------- PRESENTATION: two vertical bars ---------- */}
          <div className="absolute" style={{ left: 800, top: 60 }}>
            <div className="text-sm font-semibold mb-6 ml-2 -mt-11 text-white">Presentation</div>
 
            <div
              className="absolute"
              style={{
                left: 95,
                top: -13,
                width: 1, // changed to 1px
                height: 285 + 13,
                backgroundColor: "#8B5CF6",
              }}
            ></div>
            <RotatedBox
              onClick={() => handleClick("Visualization")}
              style={{
                width: 42,
                height: 255,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              borderColor="#00f7d0"
              text={
                <span
                  style={{
                    display: 'inline-block',
                    transform: 'rotate(360deg)',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
                >
                  Visualization
                </span>
              }
            />
          </div>
 
          <div className="absolute" style={{ left: 850, top: 60 }}>
            <RotatedBox
              onClick={() =>
                handleClick("Pandas, HTML5, D3, Bokeh, iOS/Android")
              }
              style={{
                width: 42,
                height: 255,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              borderColor="#7D67EA"
              text={
                <span
                  style={{
                    display: "inline-block",
                    transform: "rotate(360deg)",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  }}
                >
                  Pandas, HTML5, D3, Bokeh, iOS/Android
                </span>
              }
            />
          </div>
 
          {/* ---------- OUTPUT: small right column ---------- */}
          <div className="absolute" style={{ left: 900, top: 45 }}>
            <div className="text-sm font-semibold mb-5 ml-5 -mt-7 text-white">Output</div>
            <ClickableBox
              onClick={() => handleClick("Pattern")}
              style={{ left: 0, top: 60, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Pattern"
            />
            <ClickableBox
              onClick={() => handleClick("Decision")}
              style={{ left: 0, top: 110, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Decision"
            />
            <ClickableBox
              onClick={() => handleClick("Prediction")}
              style={{ left: 0, top: 160, width: 140, height: 36 }}
              borderColor="#5BC2FF"
              text="Prediction"
            />
          </div>
 
          {/* Bottom wide bar */}
          <div
            onClick={() =>
              handleClick("Cuda compatible GPGPU Compute Framework")
            }
            role="button"
            className="absolute flex items-center justify-center text-sm font-semibold cursor-pointer"
            style={{
              left: 240,
              top: 342,
              width: 720,
              height: 40,
              borderRadius: 3,
              border: "4px solid #2ef0d6",
              color: "white",
              padding: "4px 10px",
            }}
          >
            Cuda compatible GPGPU Compute Framework
          </div>
        </div>
      </div>
    </div>
  );
};
 
// ClickableBox Component (unchanged except using integer pixels)
const ClickableBox = ({ onClick, style = {}, borderColor = "#7D67EA", text = "", borderWidth = 2, highlight = false }) => {
  const defaultStyle = {
    position: "absolute",
    left: style.left || 0,
    top: style.top || 0,
    width: style.width || 200,
    height: style.height || 40,
    borderRadius: 10,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    cursor: "pointer",
    transition: "transform 120ms ease, box-shadow 160ms ease",
    whiteSpace: "nowrap",
    overflow: "hidden",
  };
 
  const bw = borderWidth || 2;
  const baseBorder = `${bw}px solid ${borderColor}`;
 
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") onClick(); }}
      style={{
        ...defaultStyle,
        border: baseBorder,
        color: "#fff",
        background: "transparent",
        ...(highlight
          ? { boxShadow: "0 0 12px rgba(46,240,214,0.15)", borderRadius: 12 }
          : {}),
      }}
      className="text-xs md:text-sm"
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-3px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <div style={{ textAlign: "center", padding: "0 6px", fontSize: 13 }}>{text}</div>
    </div>
  );
};
 
// RotatedBox Component
const RotatedBox = ({ onClick, style = {}, borderColor = "#00f7d0", text = "" }) => {
  const defaultStyle = {
    width: style.width || 44,
    height: style.height || 220,
    borderRadius: 10,
    border: `3px solid ${borderColor}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    padding: "6px",
  };
 
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") onClick(); }}
      style={defaultStyle}
      className="text-xs"
    >
      <div
        style={{
          transform: "rotate(-90deg)",
          transformOrigin: "center",
          width: style.height ? `${style.height - 12}px` : "180px",
          textAlign: "center",
          fontSize: 12,
          lineHeight: 1.05,
          color: "white",
        }}
      >
        {text}
      </div>
    </div>
  );
};
 
export default WiseFrameworkWithLines;
 
 